
import { Component } from "@angular/core";
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { ReactiveFormsModule } from "@angular/forms";
import { EmailValidator, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: true,
  imports: [ CommonModule, ReactiveFormsModule, RouterModule , NgbPaginationModule],
  selector: 'app-kb-search-category',
  templateUrl: './search-kb.component.html',
  styleUrl: './search-kb.component.scss'
})


export class KBSearchComponent {
  items: any[] = [];
  total:  number = 0;
  pageSize: number = 25;
  page: number = 1;
  public searchForm: FormGroup;

  constructor(private fb: FormBuilder, private route: ActivatedRoute,  private http: HttpClient, private router: Router) {
    this.searchForm = this.fb.group({
      searchtext: ["", Validators.required],
      domain: ["", Validators.required],
    });
  }

  send() {
    const params = { q: this.searchForm.value["searchtext"] };
      this.router.navigate(['/kb/search'], { queryParams: params });
  }

  ngOnInit()
  {
    this.load();
  }

  load() {
    this.route.queryParams.subscribe(params => {
      console.log(params); // Aqui você pode acessar os parâmetros

      const firstParamKey = Object.keys(params)[0]; // Pega a primeira chave dos parâmetros
      const firstParamValue = params[firstParamKey]; // Pega o valor correspondente à primeira chave

      this.searchForm.get('searchtext')?.setValue(firstParamValue);
     
      console.log('Primeiro parâmetro:', firstParamKey, '=', firstParamValue);

      var queryStringSearch = `?pageSize=${this.pageSize}&page=${this.page}`;
      queryStringSearch += `&searchTerm=${firstParamValue}`;

      this.http.get<any>(`${environment.apiUrl}/kb/search${queryStringSearch}` ).subscribe(
        (response) => {
          
          this.items = response.articles;
          this.total = response.total;
        },
        (error) => {
          console.error('Error:', error);
        });

    });
  }


  trocarPaginacao(page: any)
  {
    this.page = page;
    this.load();
  }

  trocarTamanhoPagina()
  {
    this.page = 1;
    this.load();
  }
  
}

